"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _accountCircleLine = _interopRequireDefault(require("./icons/account-circle-line.svg"));
var _addLine = _interopRequireDefault(require("./icons/add-line.svg"));
var _angleCircleArrowRight = _interopRequireDefault(require("./icons/angle-circle-arrow-right.svg"));
var _arrowDownSLine = _interopRequireDefault(require("./icons/arrow-down-s-line.svg"));
var _arrowLeftSLine = _interopRequireDefault(require("./icons/arrow-left-s-line.svg"));
var _arrowRightSLine = _interopRequireDefault(require("./icons/arrow-right-s-line.svg"));
var _arrowUpSLine = _interopRequireDefault(require("./icons/arrow-up-s-line.svg"));
var _autoRefresh = _interopRequireDefault(require("./icons/auto-refresh.svg"));
var _calendarEventLine = _interopRequireDefault(require("./icons/calendar-event-line.svg"));
var _calendar = _interopRequireDefault(require("./icons/calendar.svg"));
var _cart = _interopRequireDefault(require("./icons/cart.svg"));
var _checkmark = _interopRequireDefault(require("./icons/checkmark.svg"));
var _chevronDoubleDown = _interopRequireDefault(require("./icons/chevron-double-down.svg"));
var _chevronDown = _interopRequireDefault(require("./icons/chevron-down.svg"));
var _chevronLeft = _interopRequireDefault(require("./icons/chevron-left.svg"));
var _chevronRight = _interopRequireDefault(require("./icons/chevron-right.svg"));
var _chevronUp = _interopRequireDefault(require("./icons/chevron-up.svg"));
var _closeLine = _interopRequireDefault(require("./icons/close-line.svg"));
var _close = _interopRequireDefault(require("./icons/close.svg"));
var _creditCard = _interopRequireDefault(require("./icons/credit-card.svg"));
var _document = _interopRequireDefault(require("./icons/document.svg"));
var _dollarSign = _interopRequireDefault(require("./icons/dollar-sign.svg"));
var _errorOutline = _interopRequireDefault(require("./icons/error-outline.svg"));
var _error = _interopRequireDefault(require("./icons/error.svg"));
var _eyeRegular = _interopRequireDefault(require("./icons/eye-regular.svg"));
var _eyeSlashRegular = _interopRequireDefault(require("./icons/eye-slash-regular.svg"));
var _filterLine = _interopRequireDefault(require("./icons/filter-line.svg"));
var _grade = _interopRequireDefault(require("./icons/grade.svg"));
var _graph = _interopRequireDefault(require("./icons/graph.svg"));
var _guideDisable = _interopRequireDefault(require("./icons/guide-disable.svg"));
var _guide = _interopRequireDefault(require("./icons/guide.svg"));
var _help = _interopRequireDefault(require("./icons/help.svg"));
var _hourglass = _interopRequireDefault(require("./icons/hourglass.svg"));
var _infoOutline = _interopRequireDefault(require("./icons/info-outline.svg"));
var _info = _interopRequireDefault(require("./icons/info.svg"));
var _list = _interopRequireDefault(require("./icons/list.svg"));
var _location = _interopRequireDefault(require("./icons/location.svg"));
var _logout = _interopRequireDefault(require("./icons/logout.svg"));
var _mapPin4Line = _interopRequireDefault(require("./icons/map-pin-4-line.svg"));
var _mapPin5Line = _interopRequireDefault(require("./icons/map-pin-5-line.svg"));
var _mapPinLine = _interopRequireDefault(require("./icons/map-pin-line.svg"));
var _map = _interopRequireDefault(require("./icons/map.svg"));
var _menuLine = _interopRequireDefault(require("./icons/menu-line.svg"));
var _menu = _interopRequireDefault(require("./icons/menu.svg"));
var _minus = _interopRequireDefault(require("./icons/minus.svg"));
var _more = _interopRequireDefault(require("./icons/more.svg"));
var _nextArrow = _interopRequireDefault(require("./icons/next-arrow.svg"));
var _pause = _interopRequireDefault(require("./icons/pause.svg"));
var _photo = _interopRequireDefault(require("./icons/photo.svg"));
var _play = _interopRequireDefault(require("./icons/play.svg"));
var _plus = _interopRequireDefault(require("./icons/plus.svg"));
var _previousArrow = _interopRequireDefault(require("./icons/previous-arrow.svg"));
var _printer = _interopRequireDefault(require("./icons/printer.svg"));
var _refresh = _interopRequireDefault(require("./icons/refresh.svg"));
var _searchLine = _interopRequireDefault(require("./icons/search-line.svg"));
var _search = _interopRequireDefault(require("./icons/search.svg"));
var _sentimentDissatisfied = _interopRequireDefault(require("./icons/sentiment-dissatisfied.svg"));
var _sentimentVeryDissatisfied = _interopRequireDefault(require("./icons/sentiment-very-dissatisfied.svg"));
var _shoppingBasket = _interopRequireDefault(require("./icons/shopping-basket.svg"));
var _store = _interopRequireDefault(require("./icons/store.svg"));
var _subtractLine = _interopRequireDefault(require("./icons/subtract-line.svg"));
var _success = _interopRequireDefault(require("./icons/success.svg"));
var _threeDot = _interopRequireDefault(require("./icons/three-dot.svg"));
var _ticket = _interopRequireDefault(require("./icons/ticket.svg"));
var _timeLine = _interopRequireDefault(require("./icons/time-line.svg"));
var _time = _interopRequireDefault(require("./icons/time.svg"));
var _user = _interopRequireDefault(require("./icons/user.svg"));
var _warning = _interopRequireDefault(require("./icons/warning.svg"));
var _whiteClose = _interopRequireDefault(require("./icons/white-close.svg"));
var _informationLine = _interopRequireDefault(require("./icons/information-line.svg"));
var _checkboxCircleLine = _interopRequireDefault(require("./icons/checkbox-circle-line.svg"));
var _errorWarningLine = _interopRequireDefault(require("./icons/error-warning-line.svg"));
var _riStarSLine = _interopRequireDefault(require("./icons/ri-star-s-line.svg"));
var _circleFill = _interopRequireDefault(require("./icons/circle-fill.svg"));
var _circleLine = _interopRequireDefault(require("./icons/circle-line.svg"));
var _prohibitedLine = _interopRequireDefault(require("./icons/prohibited-line.svg"));
var _langAr = _interopRequireDefault(require("./icons/flags/lang-ar.svg"));
var _langAz = _interopRequireDefault(require("./icons/flags/lang-az.svg"));
var _langCa = _interopRequireDefault(require("./icons/flags/lang-ca.svg"));
var _langCs = _interopRequireDefault(require("./icons/flags/lang-cs.svg"));
var _langDa = _interopRequireDefault(require("./icons/flags/lang-da.svg"));
var _langDe = _interopRequireDefault(require("./icons/flags/lang-de.svg"));
var _langEl = _interopRequireDefault(require("./icons/flags/lang-el.svg"));
var _langEn = _interopRequireDefault(require("./icons/flags/lang-en.svg"));
var _langEs = _interopRequireDefault(require("./icons/flags/lang-es.svg"));
var _langEu = _interopRequireDefault(require("./icons/flags/lang-eu.svg"));
var _langFi = _interopRequireDefault(require("./icons/flags/lang-fi.svg"));
var _langFr = _interopRequireDefault(require("./icons/flags/lang-fr.svg"));
var _langHr = _interopRequireDefault(require("./icons/flags/lang-hr.svg"));
var _langHu = _interopRequireDefault(require("./icons/flags/lang-hu.svg"));
var _langIt = _interopRequireDefault(require("./icons/flags/lang-it.svg"));
var _langJa = _interopRequireDefault(require("./icons/flags/lang-ja.svg"));
var _langJh = _interopRequireDefault(require("./icons/flags/lang-jh.svg"));
var _langJk = _interopRequireDefault(require("./icons/flags/lang-jk.svg"));
var _langLt = _interopRequireDefault(require("./icons/flags/lang-lt.svg"));
var _langMk = _interopRequireDefault(require("./icons/flags/lang-mk.svg"));
var _langNl = _interopRequireDefault(require("./icons/flags/lang-nl.svg"));
var _langPl = _interopRequireDefault(require("./icons/flags/lang-pl.svg"));
var _langPt = _interopRequireDefault(require("./icons/flags/lang-pt.svg"));
var _langRo = _interopRequireDefault(require("./icons/flags/lang-ro.svg"));
var _langRu = _interopRequireDefault(require("./icons/flags/lang-ru.svg"));
var _langSk = _interopRequireDefault(require("./icons/flags/lang-sk.svg"));
var _langSl = _interopRequireDefault(require("./icons/flags/lang-sl.svg"));
var _langSq = _interopRequireDefault(require("./icons/flags/lang-sq.svg"));
var _langSr = _interopRequireDefault(require("./icons/flags/lang-sr.svg"));
var _langSv = _interopRequireDefault(require("./icons/flags/lang-sv.svg"));
var _langTr = _interopRequireDefault(require("./icons/flags/lang-tr.svg"));
var _langUk = _interopRequireDefault(require("./icons/flags/lang-uk.svg"));
var _langZh = _interopRequireDefault(require("./icons/flags/lang-zh.svg"));
function cov_10tso3b74r() {
  var path = "/codebuild/output/src6272852/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Icon/lib/icons.js";
  var hash = "3f8436f09abfa8f554d4891d7b985381142c2fc4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src6272852/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Icon/lib/icons.js",
    statementMap: {
      "0": {
        start: {
          line: 113,
          column: 21
        },
        end: {
          line: 147,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3f8436f09abfa8f554d4891d7b985381142c2fc4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_10tso3b74r = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_10tso3b74r(); // Country flag icon
var languageFlag = (cov_10tso3b74r().s[0]++, {
  ar: _langAr.default,
  az: _langAz.default,
  ca: _langCa.default,
  cs: _langCs.default,
  da: _langDa.default,
  de: _langDe.default,
  el: _langEl.default,
  en: _langEn.default,
  es: _langEs.default,
  eu: _langEu.default,
  fi: _langFi.default,
  fr: _langFr.default,
  hr: _langHr.default,
  hu: _langHu.default,
  it: _langIt.default,
  ja: _langJa.default,
  jh: _langJh.default,
  jk: _langJk.default,
  lt: _langLt.default,
  mk: _langMk.default,
  nl: _langNl.default,
  pl: _langPl.default,
  pt: _langPt.default,
  ro: _langRo.default,
  ru: _langRu.default,
  sk: _langSk.default,
  sl: _langSl.default,
  sq: _langSq.default,
  sr: _langSr.default,
  sv: _langSv.default,
  tr: _langTr.default,
  uk: _langUk.default,
  zh: _langZh.default
});
var _default = exports.default = {
  languageFlag: languageFlag,
  calendar: _calendar.default,
  cart: _cart.default,
  checkmark: _checkmark.default,
  'chevron-double-down': _chevronDoubleDown.default,
  'chevron-down': _chevronDown.default,
  'chevron-left': _chevronLeft.default,
  'chevron-right': _chevronRight.default,
  'chevron-up': _chevronUp.default,
  close: _close.default,
  'credit-card': _creditCard.default,
  'dollar-sign': _dollarSign.default,
  'error-outline': _errorOutline.default,
  error: _error.default,
  grade: _grade.default,
  hourglass: _hourglass.default,
  'info-outline': _infoOutline.default,
  info: _info.default,
  map: _map.default,
  menu: _menu.default,
  minus: _minus.default,
  more: _more.default,
  photo: _photo.default,
  plus: _plus.default,
  refresh: _refresh.default,
  search: _search.default,
  play: _play.default,
  pause: _pause.default,
  graph: _graph.default,
  location: _location.default,
  'auto-refresh': _autoRefresh.default,
  'sentiment-dissatisfied': _sentimentDissatisfied.default,
  'sentiment-very-dissatisfied': _sentimentVeryDissatisfied.default,
  'shopping-basket': _shoppingBasket.default,
  success: _success.default,
  'three-dot': _threeDot.default,
  time: _time.default,
  warning: _warning.default,
  user: _user.default,
  list: _list.default,
  printer: _printer.default,
  ticket: _ticket.default,
  'eye-regular': _eyeRegular.default,
  'eye-slash-regular': _eyeSlashRegular.default,
  'white-close': _whiteClose.default,
  help: _help.default,
  'next-arrow': _nextArrow.default,
  'previous-arrow': _previousArrow.default,
  logout: _logout.default,
  store: _store.default,
  document: _document.default,
  guide: _guide.default,
  guideDisable: _guideDisable.default,
  'angle-circle-arrow-right': _angleCircleArrowRight.default,
  riArrowLeftSLine: _arrowLeftSLine.default,
  riArrowRightSLine: _arrowRightSLine.default,
  riArrowDownSLine: _arrowDownSLine.default,
  riArrowUpSLine: _arrowUpSLine.default,
  riSearchLine: _searchLine.default,
  riTimeLine: _timeLine.default,
  riCalendarEventLine: _calendarEventLine.default,
  riMapPinLine: _mapPinLine.default,
  riMenuLine: _menuLine.default,
  riCloseLine: _closeLine.default,
  riFilterLine: _filterLine.default,
  riMapPin4Line: _mapPin4Line.default,
  riMapPin5Line: _mapPin5Line.default,
  'add-line': _addLine.default,
  'subtract-line': _subtractLine.default,
  'account-circle-line': _accountCircleLine.default,
  riInformationLine: _informationLine.default,
  riCheckBoxCircleLine: _checkboxCircleLine.default,
  riErrorWarningLine: _errorWarningLine.default,
  riStarSLine: _riStarSLine.default,
  circleFill: _circleFill.default,
  circleLine: _circleLine.default,
  prohibitedLine: _prohibitedLine.default
};